var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231,
    height: 200.266,
    viewBox: "0 0 231 200.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "School",
    transform: "translate(0 -34.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_41_",
    transform: "translate(0 34.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_42---Education",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_162_",
    d: "M224.313,82.648,123.943,36.894a20.354,20.354,0,0,0-16.886,0L6.692,82.648a11.076,11.076,0,0,0,0,20.343L38.5,117.49v52.329c0,8.855,5.74,16.867,15.4,23.3v11.9a15.4,15.4,0,1,0,7.7,0v-7.477a126.2,126.2,0,0,0,53.9,10.78c43.178,0,77-16.913,77-38.5V117.49l31.808-14.5a11.076,11.076,0,0,0,0-20.343ZM65.45,219.869a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,65.45,219.869ZM46.2,169.819V121l7.7,3.511v59.116A18.791,18.791,0,0,1,46.2,169.819Zm138.6,0c0,16.7-31.735,30.8-69.3,30.8-21.51,0-41.076-4.62-53.9-11.723V128.024l45.457,20.72a20.327,20.327,0,0,0,16.886,0L184.8,121v48.818ZM221.117,95.98,120.752,141.738a12.826,12.826,0,0,1-10.5,0L66.64,121.856l33.953-17.19A30.889,30.889,0,0,0,115.5,108.22c12.951,0,23.1-6.764,23.1-15.4s-10.149-15.4-23.1-15.4-23.1,6.764-23.1,15.4a11.4,11.4,0,0,0,2,6.348l-36.733,18.6L9.883,95.98a3.38,3.38,0,0,1,0-6.322L110.249,43.9a12.816,12.816,0,0,1,10.5,0L221.117,89.659a3.38,3.38,0,0,1,0,6.321ZM100.1,92.819c0-3.634,6.583-7.7,15.4-7.7s15.4,4.066,15.4,7.7-6.583,7.7-15.4,7.7S100.1,96.454,100.1,92.819Z",
    transform: "translate(0 -35.061)",
    fill: "#1c6bfe"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/School.546ccb93b6adc23a9fb501cf60e9bd40.svg";
export { ForwardRef as ReactComponent };